import request from '@/utils/request'
import requestBlack from './request-blacklist'
const baseUrl = process.env.VUE_APP_PURCHASE_API
const baseUrlBlack = process.env.VUE_APP_EXTERNAL_BLACKLIST_API

// 新增黑名单信息
export function addSupplierBlacklistApi(data) {
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/add`,
    method: 'post',
    data
  })
}

// 编辑黑名单
export function editSupplierBlacklistApi(data) {
  const { blacklistId, ...other } = data
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/${blacklistId}/edit`,
    method: 'put',
    data: other
  })
}

// 启用黑名单
export function enabledSupplierBlacklistApi(data) {
  const { blacklistId, ...other } = data
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/${blacklistId}/enabled`,
    method: 'post',
    data: other
  })
}

// 禁用黑名单
export function forbiddenSupplierBlacklistApi(data) {
  const { blacklistId, ...other } = data
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/${blacklistId}/forbidden`,
    method: 'post',
    data: other
  })
}

// 黑名单列表分页
export function getSupplierBlacklistListApi(params) {
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/blacklist/page`,
    method: 'get',
    params
  })
}

// 黑名单操作记录列表分页
export function getSupplierBlacklistLogListApi(params) {
  const { blacklistId, ...other } = params
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/${blacklistId}/log-page`,
    method: 'get',
    params: other
  })
}

// 同步企业黑名单
export function syncCompanySupplierBlacklistApi(data) {
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/blacklist/sync-company`,
    method: 'post',
    data
  })
}

// 同步公司黑名单列表分页
export function getCompanyBlacklistSyncListApi(params) {
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/blacklist/sync-page`,
    method: 'get',
    params
  })
}

// 查询同步黑名单公司信息
export function getSyncBlacklistCompanyListApi() {
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/sync-company/list`,
    method: 'get'
  })
}

// 导入供应商黑名单
export function importSupplierBlacklistApi(data) {
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/import-blacklist`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  }, true, true)
}

// 预览附件
export function previewBlacklistFileApi(params) {
  const { blacklistId, ...other } = params
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/${blacklistId}/preview-file`,
    method: 'get',
    params: other
  })
}

// 下载附件
export function downloadBlacklistFileApi(params) {
  const { blacklistId, ...other } = params
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist/${blacklistId}/download-file`,
    method: 'get',
    params: other
  })
}

// 外部黑名单——政府采购严重违法失信行为记录名单列表分页
export function getOuterBlacklistListApi(params) {
  return request({
    url: `${baseUrl}/workbench/supplier-blacklist-out/outer-blacklist/page`,
    method: 'get',
    params
  })
}

// 外部黑名单——查询(严重失信主体、经营异常)
export function getExternalBlacklistBySearchApi(params) {
  return requestBlack({
    url: `${baseUrlBlack}/behavior_search`,
    method: 'get',
    params
  })
}
